'use client'

import { useRef, useState } from 'react'
import { LuCircleHelp } from 'react-icons/lu'

import { Button } from '@/core/components/form/button/button'
import GuidedTour, { guidedTourTarget } from '@/core/components/guided-tour'

import type { GuidedTourStep } from '@/core/components/guided-tour'

export default function StudioTutorial({
  steps,
  disabled,
}: {
  steps: () => GuidedTourStep[]
  disabled?: boolean
}) {
  const [active, setActive] = useState<GuidedTourStep[] | null>(null)
  const trigger = useRef<HTMLButtonElement>(null)
  return (
    <>
      <Button
        ref={trigger}
        variant="ghost"
        size="sm"
        aria-label="튜토리얼"
        title="튜토리얼"
        className="flex-none text-gray"
        disabled={disabled}
        onClick={() => {
          const available = steps().filter((step) =>
            guidedTourTarget(step.target)
          )
          if (available.length) setActive(available)
        }}
      >
        <LuCircleHelp aria-hidden="true" className="size-4" />
        튜토리얼
      </Button>
      {active && (
        <GuidedTour
          label="스튜디오 가이드"
          steps={active}
          onClose={() => setActive(null)}
          returnFocus={trigger}
        />
      )}
    </>
  )
}
